import { DatePicker, Input, InputNumber, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";

const getInput = ({
  inputType,
  enums = [],
  enumDictionary = {},
  value,
  onChange,
  onPressEnter,
  ...restProps
}) => {
  if (enums.length > 0) {
    return (
      <Select
        className="pptable_filter_input"
        style={{ width: "100%" }}
        options={enums.map((key) => ({
          value: key,
          label: enumDictionary[key] || key,
        }))}
        value={value}
        onChange={onChange}
        allowClear
        {...restProps}
      />
    );
  }
  switch (inputType) {
    case "date":
      return (
        <DatePicker
          className="pptable_filter_input"
          value={value ? moment(value) : undefined}
          onChange={(value) => onChange(value)}
          style={{ width: "100%" }}
          allowClear
          {...restProps}
        />
      );
    case "number":
      return (
        <InputNumber
          className="pptable_filter_input"
          value={value}
          onChange={onChange}
          style={{ width: "100%" }}
          onPressEnter={onPressEnter}
          controls={false}
          prefix={<SearchOutlined />}
          {...restProps}
        />
      );
    default:
      return (
        <Input
          className="pptable_filter_input"
          value={value}
          placeholder="Хайх"
          onChange={(e) => onChange(e.target.value)}
          onPressEnter={onPressEnter}
          prefix={<SearchOutlined />}
          allowClear
          {...restProps}
        />
      );
  }
};

// <PPTableSearchInput
//   dataIndex={dataIndex}
//   value={filter[dataIndex]}
//   onChange={(e) =>
//     handleChangeSearchInput(dataIndex, e.target.value)
//   }
//   onPressEnter={(e) => {
//     fetchList(filter);
//   }}
// />

const FILTER_TYPES = [
  "startsWith",
  "contains",
  "equals",
  "notEquals",
  "endsWith",
  "notContains",
  "empty",
  "list"
];

const FILTER_TYPES_DICTIONARY = {
  startsWith: "Эхэлсэн",
  contains: "Агуулсан",
  equals: "Тэнцүү",
  notEquals: "Тэнцүү биш",
  endsWith: "Төгссөн",
  notContains: "Агуулаагүй",
  empty: "Хоосон",
  list: "Жагсаалтаас"
};

export { getInput, FILTER_TYPES, FILTER_TYPES_DICTIONARY };
